import client from "../apolloClient";
import { GET_VIEW_URL } from "../queries/file.queries";

export const getViewURL = async (key: string) => {
  try {
    // Helper function to check if a string is a URL
    const isURL = (str: string): boolean => {
      return /^https?:\/\//.test(str);
    };

    // If it's already a URL, return it as-is
    if (isURL(key)) {
      console.log('Key is already a URL, returning as-is:', key);
      return {
        success: true,
        message: 'URL provided',
        viewURL: key
      };
    }

    console.log('Fetching view URL for key:', key);
    
    const { data, errors } = await client.mutate({
      mutation: GET_VIEW_URL,
      variables: { key },
    });

    if (errors) {
      console.error('Error fetching view URL:', errors);
      throw new Error(errors[0].message);
    }

    return data.getViewURL;
  } catch (error: any) {
    console.error('Error fetching view URL:', {
      error: error.message,
      networkError: error.networkError?.message,
      graphQLErrors: error.graphQLErrors,
    });
    throw error;
  }
};
